import React from "react"

import { NotificationManager } from "react-notifications"
import { gql, useMutation } from "urql"

import PromptAnswers from "./PromptAnswers"
import { PromptWithResponses } from "./types"

type ActivePromptProps = {
  prompt: PromptWithResponses
  presentStudents: { fullName: string; id: string }[]
}

const ActivePrompt = ({ prompt, presentStudents }: ActivePromptProps) => {
  const [mutationState, runMutation]: any[] = useMutation(closePromptMutation)
  const answeredIds = prompt.responses.map(response => response.student.id)
  const unansweredCount = presentStudents.filter(
    student => !answeredIds.includes(student.id)
  ).length

  const close = () => {
    runMutation({ promptId: prompt.id })
      .then(result => {
        const { failures } = result.data.closeAcrClassPrompt
        if (failures.length > 0) {
          NotificationManager.error(failures[0].message)
        }
      })
      .catch(() => NotificationManager.error("Unable to close question"))
  }

  return (
    <div>
      <div className="mb-3 flex items-start justify-between gap-4">
        <div>
          <p className="text-lg font-semibold">{prompt.body}</p>
          <p className="mt-1 text-sm text-neutral-400">
            {prompt.responses.length} answered · {unansweredCount} waiting
          </p>
        </div>
        <button
          type="button"
          disabled={mutationState.fetching}
          onClick={close}
          className="flex-none rounded-lg border border-solid border-red-600 bg-red-700 px-4 py-2 text-sm font-semibold text-white hover:bg-red-600 disabled:opacity-60"
        >
          {mutationState.fetching ? "Closing..." : "Close question"}
        </button>
      </div>
      <div className="max-h-64 overflow-y-auto">
        <PromptAnswers prompt={prompt} presentStudents={presentStudents} />
      </div>
    </div>
  )
}

const closePromptMutation = gql`
  mutation CloseAcrClassPrompt($promptId: ID!) {
    closeAcrClassPrompt(promptId: $promptId) {
      failures {
        message
      }
    }
  }
`

export default ActivePrompt
